import Model from "./Model";
import { CampaignLaunch, Product, Alert } from ".";

export default class AlertFeed extends Model {
  static type = "alertFeeds";

  referenceDate!: string;
  alert!: Alert;
  campaignLaunch!: CampaignLaunch;

  get isValid() {
    return this.campaignLaunch instanceof CampaignLaunch;
  }

  get date(): string {
    return this.campaignLaunch.date;
  }

  get product(): Product {
    return this.campaignLaunch.product;
  }

  get broadcasters(): number {
    return this.campaignLaunch.broadcastersCount;
  }

  get spots(): number {
    return this.campaignLaunch.spotsCount;
  }

  get seconds(): number {
    return this.campaignLaunch.seconds;
  }

  get isRadio(): boolean {
    return this.campaignLaunch.media?.isRadio;
  }

  get isTV(): boolean {
    return this.campaignLaunch.media?.isTV;
  }
}
